let getTokenFn: (() => Promise<string | null>) | null = null;

export function setTokenGetter(fn: () => Promise<string | null>) {
  getTokenFn = fn;
}

export async function getAuthToken(): Promise<string | null> {
  return getTokenFn ? getTokenFn() : null;
}
